module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "d-flex flex-column flex-wrap"
  }, [_c('label', {
    staticClass: "fs-6"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (!_vm.editing) ? _c('div', {
    staticClass: "d-flex flex-wrap ml-0 mt-0 mb-0 align-items-center"
  }, [_c('div', {
    staticClass: "grow-1 mt-0 mr-2"
  }, [(_vm.value) ? _c('h2', {
    staticClass: "title is-4 mt-0"
  }, [_vm._v(_vm._s(_vm.value))]) : _c('h2', {
    staticClass: "title is-4 mt-0 text-muted"
  }, [_vm._v("none set")])]), _vm._v(" "), _c('button', {
    staticClass: "button mb-1 is-link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setEditing(true)
      }
    }
  }, [_vm._v("Edit")])]) : _c('form', {
    staticClass: "d-flex flex-wrap ml-0 mt-0 mb-0",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveValue($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedValue),
      expression: "editedValue"
    }],
    staticClass: "column ml-0 mt-0 input mr-2 mb-1",
    attrs: {
      "placeholder": _vm.placeholder,
      "id": 'input-' + _vm.title
    },
    domProps: {
      "value": (_vm.editedValue)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        _vm.setEditing(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editedValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('button', {
    staticClass: "button mr-1 is-link grow-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setEditing(false)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button is-info grow-1",
    class: _vm.loading && 'is-loading',
    attrs: {
      "type": "submit",
      "disabled": !_vm.edited
    }
  }, [_vm._v("Save")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-27f557d6"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SettingsProfileField.vue
// module id = 998
// module chunks = 0